export default class ProductOptionManagementColumnModel {
	static Column = [
	  {
		  title: 'Name',
		  align: 'left',
		  field: 'optionName'
	  },
		{
			title: 'Price',
			align: 'left',
			type: 'numeric',
			field: 'price'
		}
	]
}
